import { useCallback } from 'react';
import { PointOfInterestDto } from '../../../models/dtos/point-of-interest-dto';
import { ShortDto } from '../../../models/short-dto';
import instance from '../../index';
import { BaseResponse } from '../../../models/base-response';
import { PagedList } from '../../../models/paged-list';
import { BonusConfig } from "../../../models/bonusConfig";

interface CreatePointOfInterestData {
    name: string;
    description: string;
    latitude: number;
    longitude: number;
}

const usePointOfInterestService = () => {
    const getPointsOfInterestShort = useCallback(async (): Promise<ShortDto[]> => {
        const response = await instance.get<BaseResponse<ShortDto[]>>('/v1/backoffice/points-of-interest/short');
        return response?.data?.data || [];
    }, []);

    const getPointOfInterest = useCallback(async (): Promise<PagedList<PointOfInterestDto>> => {
        const response = await instance.get<BaseResponse<PagedList<PointOfInterestDto>>>('/v1/backoffice/points-of-interest');
        return response?.data?.data;
    }, []);

    const getPointOfInterestById = useCallback(async (id: string): Promise<PointOfInterestDto> => {
        const response = await instance.get<BaseResponse<PointOfInterestDto>>(`/v1/backoffice/points-of-interest/${id}`);
        return response?.data?.data;
    }, []);

    const createPointOfInterest = useCallback(async (data: CreatePointOfInterestData): Promise<PointOfInterestDto> => {
        const response = await instance.post<BaseResponse<PointOfInterestDto>>('/v1/backoffice/points-of-interest', data);
        return response?.data?.data;
    }, []);

    return {
        getPointsOfInterestShort,
        getPointOfInterest,
        getPointOfInterestById,
        createPointOfInterest
    };
};

export default usePointOfInterestService; 